"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeSnackbarRepo = void 0;
const Result_1 = require("../ValueObjects/Result");
const ObserverList_1 = require("./ObserverList");
function makeSnackbarRepo() {
    return new SnackbarRepoImp();
}
exports.makeSnackbarRepo = makeSnackbarRepo;
class SnackbarRepoImp {
    constructor(defaultDurationInSeconds = 4) {
        this.monitoringSnackbarTime = false;
        this.observers = new ObserverList_1.ObserverList();
        this.makeSnackbar = (message, snackbarAction, durationInSeconds) => {
            if (message.trim().length === 0) {
                const err = new Error('Snackbar must have a message');
                return (0, Result_1.reject)(err);
            }
            if (snackbarAction && snackbarAction.actionButtonText.trim().length === 0) {
                const err = new Error('If a Snackbar has an action then the action button text cannot be empty');
                return (0, Result_1.reject)(err);
            }
            const duration = durationInSeconds !== null && durationInSeconds !== void 0 ? durationInSeconds : this.defaultDurationInSeconds;
            if (duration <= 0) {
                const err = new Error(`${duration} is an invalid duration for a Snackbar`);
                return (0, Result_1.reject)(err);
            }
            const snackbar = {
                message,
                durationInSeconds: duration,
                snackbarAction,
            };
            this.snackbarQueue.push(snackbar);
            this.observers.notify(this.getCurrentSnackbar());
            this.monitorSnackbarTime();
            return (0, Result_1.resolve)(null);
        };
        this.getCurrentSnackbar = () => {
            return this.snackbarQueue.length > 0 ? this.snackbarQueue[0] : undefined;
        };
        this.dismissActiveSnackbar = () => {
            if (this.snackbarQueue.length > 0) {
                this.snackbarQueue.splice(0, 1);
                this.observers.notify(this.getCurrentSnackbar());
            }
        };
        this.callActiveSnackbarAction = () => {
            const currentSnackbar = this.getCurrentSnackbar();
            if (currentSnackbar) {
                if (currentSnackbar.snackbarAction) {
                    currentSnackbar.snackbarAction.action();
                    this.dismissActiveSnackbar();
                }
            }
        };
        this.addObserver = (observer) => {
            this.observers.add(observer);
        };
        this.removeObserver = (observer) => {
            this.observers.remove(observer);
        };
        this.snackbarQueue = [];
        this.defaultDurationInSeconds = defaultDurationInSeconds;
    }
    monitorSnackbarTime() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.monitoringSnackbarTime) {
                return;
            }
            const loopFrequencyInSeconds = 0.1;
            this.monitoringSnackbarTime = true;
            while (this.snackbarQueue.length > 0) {
                const currentSnackbar = this.getCurrentSnackbar();
                if (currentSnackbar) {
                    let currentTimeout = currentSnackbar.durationInSeconds;
                    while (this.getCurrentSnackbar() === currentSnackbar && currentTimeout > 0) {
                        // tslint:disable-next-line:no-shadowed-variable
                        yield new Promise((resolve) => setTimeout(resolve, loopFrequencyInSeconds * 1000));
                        currentTimeout -= loopFrequencyInSeconds;
                    }
                    if (this.getCurrentSnackbar() === currentSnackbar && currentTimeout <= 0) {
                        this.dismissActiveSnackbar();
                    }
                }
            }
            this.monitoringSnackbarTime = false;
        });
    }
}
